// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMantineTheme } from '@mantine/core';
import { Badge, Box, Button, Container, PasswordInput, Stack, Text, Title } from '@/components/ui';
import { IconArrowLeft, IconSparkles } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';
import { PasswordStrength } from '../components';

export default function ResetGlassmorphism() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const theme = useMantineTheme();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', { password, confirmPassword });
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundImage: 'url(https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(8px)',
        }}
      />

      <Box mih="100vh" py="xl" px="md" style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center' }}>
        <Container size="xs" w="100%">
          <SlideIn direction="up" delay={100}>
            <Box
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(20px) saturate(180%)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: theme.radius.lg,
                padding: '2.5rem',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
              }}
            >
              <Stack gap="lg">
                <Button
                  component={Link}
                  to="/demo/auth-pages/reset-password"
                  variant="subtle"
                  size="xs"
                  leftSection={<IconArrowLeft size={14} />}
                  w="fit-content"
                  c="white"
                >
                  Back to variants
                </Button>

                <FadeIn delay={200}>
                  <Stack gap="xs" align="center">
                    <Badge
                      leftSection={<IconSparkles size={12} />}
                      variant="white"
                      size="lg"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                      }}
                    >
                      Glassmorphism
                    </Badge>
                    <Title order={2} ta="center" c="white" mt="md">
                      Reset your password
                    </Title>
                    <Text c="white" size="sm" ta="center" style={{ opacity: 0.9 }}>
                      Create a new strong password for your account
                    </Text>
                  </Stack>
                </FadeIn>

                <SlideIn direction="up" delay={300}>
                  <form onSubmit={handleSubmit}>
                    <Stack gap="md">
                      <PasswordInput
                        label="New password"
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        styles={{
                          label: { color: 'white', fontWeight: 500 },
                          input: {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: 'white',
                            '&::placeholder': { color: 'rgba(255, 255, 255, 0.6)' },
                            '&:focus': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                          },
                          innerInput: { color: 'white' },
                        }}
                      />

                      <PasswordStrength password={password} />

                      <PasswordInput
                        label="Confirm password"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        styles={{
                          label: { color: 'white', fontWeight: 500 },
                          input: {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: 'white',
                            '&::placeholder': { color: 'rgba(255, 255, 255, 0.6)' },
                            '&:focus': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                          },
                          innerInput: { color: 'white' },
                        }}
                      />

                      <Button
                        type="submit"
                        fullWidth
                        size="md"
                        variant="white"
                        style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        Reset password
                      </Button>
                    </Stack>
                  </form>
                </SlideIn>
              </Stack>
            </Box>
          </SlideIn>
        </Container>
      </Box>
    </Box>
  );
}
